




















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { HeaderList } from '@/components/Table/TableModel';

import Table from '@/components/molecules/Table/Table.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';

import AdminService from '@/api/AdminService';

import { Pagination, SortController } from '@/utils/Pagination';
import { IPeriod } from '@/models/period';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import ContextMenuOption from '@/components/ContextMenu/ContextMenuOption';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { EDealType } from '@/views/Admin/CoinStore/DealForm.vue';

@Component({
  components: { Table, TableHeader, TableRow, TableCell, ContextMenu }
})
export default class CoinStoreDealsList extends Vue {
  @Prop(String) readonly coinStoreId?: string;
  @Prop() readonly period?: IPeriod;

  service: AdminService = new AdminService();
  pagination = new Pagination(this.formatRow);
  sort = new SortController();
  query: any = {};
  headers = [
    new HeaderList(`Type`, 'dealType', '12px 12px 12px 32px', 'left'),
    new HeaderList(
      `Coins/Purchase Amount`,
      'coins',
      '12px 12px 12px 0px',
      'left'
    ),
    new HeaderList(`Status`, 'status', '12px 32px 12px 12px', 'left'),
    new HeaderList(``, 'none', '12px')
  ];

  get dealTypeLabelMap() {
    return new Map([
      [EDealType.COIN_DEAL, 'Hot Deal'],
      [EDealType.COIN_BUNDLE, 'Coin Bundle'],
      [EDealType.DUO_COIN_DEAL, 'Duo Deal'],
      [EDealType.FIRST_COIN_DEAL, 'First Coin Deal']
    ]);
  }

  formatValue(value: string | number): string {
    const numValue = Number(value);

    return Number.isInteger(numValue)
      ? numValue.toString()
      : numValue.toFixed(2);
  }

  formatRow(row: any) {
    const coins = row.coins || '0';
    const value = row.value || '0';
    return {
      id: row.id,
      coins: this.formatValue(coins),
      value: this.formatValue(value),
      status: row.status || 'available',
      dealType: this.dealTypeLabelMap.get(row.dealType) || '--'
    };
  }

  getOptionsByData(deal: any): ContextMenuOption[] {
    return [
      {
        label: 'Remove',
        action: 'removeDeal'
      }
    ];
  }

  optionSelected(action: string, props: Array<any>, deal: any): void {
    switch (action) {
      case 'removeDeal':
        this.deleteCoinDealConfirmation(deal.id);
        break;
      default:
        break;
    }
  }

  deleteCoinDealConfirmation(id: string) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'coinStoreDealConfirmModal',
        hideCancelButton: false,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        data: {
          id
        },
        title: `Are you sure?`,
        subtitle: `A deal will be deleted`,
        onConfirm: () => {
          this.deleteCoinDeal(id);
        }
      }
    );
  }

  deleteCoinDeal(id: string) {
    this.$showLoaderWithLocker();
    this.service.deleteCoinDeal(id).then(res => {
      this.$hideLoader();
      if (res.status === 200) {
        this.$notification('Coin deal deleted successfully');
        this.updateSort();
        eventBus.$emit('closeModal');
        eventBus.$emit('reloadCoinStore');
      }
    });
  }

  updateSort(field: string = 'coins') {
    this.sort.update(field);
    this.query = {
      ...this.query,
      sort: this.sort.toString()
    };
  }

  @Watch('query')
  refreshPagination(query: any) {
    this.pagination.refresh(
      `/super-admin/coin-store-deal/${this.coinStoreId}/list`,
      query
    );
  }

  mounted() {
    eventBus.$on('reloadCoinDealsList', this.updateSort);
    this.updateSort();
    this.pagination.setPaginationTarget(this.$refs.target as HTMLElement);
  }

  beforeDestroy() {
    eventBus.$off('reloadCoinDealsList', this.updateSort);
  }
}
